import { IAddress } from ".";

type parts = "city" | "state" | "postal";

export const formatAddress = (
  address: IAddress,
  twoLines: boolean = false,
  omitParts: parts[] = [],
  minorArea: string | undefined | null = null,
) => {
  let line_1: string[] = [];
  address.street1 && line_1.push(address.street1);
  address.street2 && line_1.push(address.street2);
  line_1.length == 0 && address.text && line_1.push(address.text);

  let line_2: string[] = [];
  !omitParts.includes("city") && address.city && line_2.push(address.city);
  minorArea && line_2.push(minorArea);
  !omitParts.includes("state") && address.state && line_2.push(address.state);
  !omitParts.includes("postal") &&
    address.postal &&
    line_2.push(address.postal);

  return `${line_1.join(", ")}${
    twoLines ? "\n" : line_2.length > 0 ? ", " : ""
  } ${line_2.join(", ")}`;
};